import * as tslib_1 from "tslib";
import store from '../../store';
import * as qs from 'qs';
import { isWeixin } from '@ivy/fts/utils';
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
let PopupPay = class PopupPay extends Vue {
    constructor() {
        super(...arguments);
        this.store = store;
        this.order = '';
        this.isWeixin = isWeixin();
    }
    onShowPanelChanged() {
        if (!this.showPanel) {
            this.$emit('on-item-close');
        }
    }
    get getPrice() {
        return ((+this.album.sale_price * 100 - +this.album.vip_sale_price * 100) / 100).toFixed(2);
    }
    setOrder(type) {
        if (type === 'vip') {
            let from = `${window.location.pathname}${window.location.search}`;
            return this.$router.push({ path: '/vip', query: { from, action: 'callPay' } });
        }
        this.order = type;
        this.showPanel = true;
    }
    async weChatPay() {
        let from = `${window.location.pathname}${window.location.search}`;
        if (!store.logined.token)
            return store.bindPhone(from);
        // this.$Indicator.open()
        let order = {
            type: this.orderType,
            openid: store.logined.openid,
            id: this.album.id,
        };
        let { data: pay } = await this.$axios.post(`/api/goods/order/old/general/createOrderWechat`, order);
        delete pay.order;
        // 如果不需要付款
        if (+pay.total_fee < 0.01 || !pay.appId) {
            return window.location.reload();
        }
        if (this.isWeixin) {
            window.location.href = `//${window.location.host}/pay/?${qs.stringify({ pay, redirect: window.location.href })}`;
        }
        else {
            // 这暂时改为支付（成功或者失败）后跳首页，之后要改为重定向为当前会员页面
            window.location.href = `${pay.mweb_url}&redirect_url=${encodeURIComponent(window.location.href)}`;
        }
    }
};
tslib_1.__decorate([
    Prop()
], PopupPay.prototype, "album", void 0);
tslib_1.__decorate([
    Prop()
], PopupPay.prototype, "showPanel", void 0);
tslib_1.__decorate([
    Prop()
], PopupPay.prototype, "orderType", void 0);
tslib_1.__decorate([
    Watch('showPanel')
], PopupPay.prototype, "onShowPanelChanged", null);
PopupPay = tslib_1.__decorate([
    Component
], PopupPay);
export default PopupPay;
